import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from 'prop-types';

import * as networkAction from "../../actions/networkActions";

import Modal from "reboron/DropModal";
import { PageHeader } from "../../components/PageHeader";

import LoadingTable from "../../components/LoadingTable";
import NetworkView from "../../components/NetworkView";

import { formatDateTime } from "../../helpers/utils";
import { Activity, checkUserActivity } from "../../helpers/userActivity";

/**
 * Kompoment z kolekcją sieci
 */
class Networks extends Component {
  state = {
    //zawartosc modala (doda, edytuj, usun)
    modalContent: null,
    //czy dane do tabelki sie zaladowaly
    loading: true
  };

  componentDidMount() {

    this._isMounted = true;

    //ladowanie danych do tabelki
    this.props.onFetch(() => {
      //po pobraniu danych do tabelki zmieniamy stan na zaladowany jesli jeszcze komponent jest aktywny
      if (this._isMounted) {
        this.setState({ loading: false });
      }
    });
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  /**
   * Kolumny do tabelki
   */
  tableColumns = [
    {
      Header: this.props.formatMessage("network.id"),
      accessor: "id",
      headerStyle: { whiteSpace: "unset" },
      style: { whiteSpace: "unset", textAlign: "right" }
    },
    {
      Header: this.props.formatMessage("network.name"),
      accessor: "name",
      headerStyle: { whiteSpace: "unset" },
      style: { whiteSpace: "unset" }
    },
    {
      Header: this.props.formatMessage("network.description"),
      accessor: "description",
      headerStyle: { whiteSpace: "unset" },
      style: { whiteSpace: "unset" }
    },
    {
      Header: this.props.formatMessage("network.creationDate"),
      id: "creationDate",
      headerStyle: { whiteSpace: "unset" },
      style: { whiteSpace: "unset" },
      maxWidth: 180,
      accessor: data => {
        return formatDateTime(data.creationDate);
      }
    },
    {
      Header: this.props.formatMessage("network.modificationDate"),
      id: "modificationDate",
      headerStyle: { whiteSpace: "unset" },
      style: { whiteSpace: "unset" },
      maxWidth: 180,
      accessor: data => {
        return formatDateTime(data.modificationDate);
      }
    },
    {
      Header: "",
      Cell: row => (
        <div>
          <button
            className="w3-button w3-text-theme w3-hover-none w3-hover-text-theme-dark"
            onClick={() => this.onRowEditClick(row.original)}
          >
            <i className="far fa-edit" />
          </button>
          <button
            className="w3-button w3-text-theme w3-hover-none w3-hover-text-theme-dark"
            onClick={() => this.onRowDeleteClick(row.original)}
          >
            <i className="fas fa-trash-alt" />
          </button>
        </div>
      )
    }
  ];

  /**
   * Pokazuje modal
   */
  showModal() {
    this.refs.modal.show();
  }

  /**
   * Chowa modal
   */
  hideModal = () => {
    if (this.state.modalContent !== null) {
      this.setState({ modalContent: null });
      this.refs.modal.hide();
    }
  };

  /**
   * Akcja na klik przycisku dodania
   */
  onAddButtonClick = () => {
    //domyslmy model sieci
    let defaultNetwork = {
      name: "",
      description: ""
    };
    this.setState({
      modalContent: (
        <NetworkView
          title={this.props.formatMessage("app.networkPage.addNetwork")}
          network={defaultNetwork}
          cancelText={this.props.formatMessage("app.action.cancel")}
          sumbitText={this.props.formatMessage("app.action.submit")}
          onCancel={this.hideModal}
          onSubmit={this.onCreateAction}
        />
      )
    });

    this.showModal();
  };

  /**
   * Akcja na klik edycji wiersza w tabelce
   */
  onRowEditClick = data => {
    this.setState({
      modalContent: (
        <NetworkView
          title={this.props.formatMessage("app.networkPage.editNetwork")}
          network={data}
          cancelText={this.props.formatMessage("app.action.cancel")}
          sumbitText={this.props.formatMessage("app.action.submit")}
          onCancel={this.hideModal}
          onSubmit={this.onUpdateAction}
        />
      )
    });

    this.showModal();
  };

  /**
   * Akcja na klik kasowania wiersza w tabelce
   */
  onRowDeleteClick = data => {
    this.setState({
      modalContent: (
        <NetworkView
          title={this.props.formatMessage("app.networkPage.deleteNetwork")}
          network={data}
          cancelText={this.props.formatMessage("app.action.cancel")}
          sumbitText={this.props.formatMessage("app.action.delete")}
          onCancel={this.hideModal}
          onSubmit={() => this.onDeleteAction(data)}
        />
      )
    });

    this.showModal();
  };

  /**
   * Akcja po zatwierdzeniu tworzenia
   */
  onCreateAction = data => {
    this.props.onCreate(data);
    this.hideModal();
  };

  /**
   * Akcja po zatwierdzeniu aktualizacji
   */
  onUpdateAction = data => {
    this.props.onUpdate(data);
    this.hideModal();
  };

  /**
   * Akcja po zatwierdzeniu kasowania
   */
  onDeleteAction = data => {
    this.props.onDelete(data);
    this.hideModal();
  };

  addButton() {
    return <button
      className="w3-btn w3-theme-dark"
      onClick={() => this.onAddButtonClick()}
    >
      {this.props.formatMessage("app.networkPage.addNetwork")}
    </button>
  }

  render() {
    return (
      <div>
        <PageHeader text="app.networkPage.title" />

        {checkUserActivity(this.props.authenticatedUser, Activity.ADD_NETWORK) && this.addButton()}

        <Modal ref={"modal"}>{this.state.modalContent}</Modal>

        <LoadingTable
          data={this.props.networkList}
          columns={this.tableColumns}
          loading={this.state.loading}
        />
      </div>
    );
  }
}

Networks.propTypes = {
  formatMessage: PropTypes.func.isRequired
};

const mapStateToProps = state => {
  return {
    networkList: state.networkReducer.networkList,
    authenticatedUser: state.authReducer.authenticatedUser
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onFetch: callback => {
      dispatch(networkAction.fetchNetworks(callback));
    },
    onDelete: network => {
      dispatch(networkAction.deleteNetwork(network.id));
    },
    onCreate: network => {
      dispatch(networkAction.createNetwork(network));
    },
    onUpdate: network => {
      dispatch(networkAction.updateNetwork(network));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Networks);
